import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Subscription } from 'rxjs';
import { PaginationCriteria} from 'jul-web-shared-lib';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { TaskService } from '../services/task.service';
import { AlertifyService } from 'jul-web-shared-lib/src/lib/components/alertify';
import * as _ from "lodash";
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { Task } from '../core/models/notifications/task.model';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit, OnDestroy {

  tasksData: any;
  timerNotification: TimerObservable<any>;
  isLoaded = false;
  loading = false;
  error = false;
  opened = false;
  maxResults = 5;
  unreadTasks: number = null;
  criteria = new PaginationCriteria<Task>(this.maxResults, [{
    "direction": "DESC",
    "attribute": "screenDate"
  }], {}, this.maxResults, 1);
  timerTask: TimerObservable<any>;


  private subscription: Subscription;
  audio = new Audio('assets/sounds/notification-sound.mp3');
  subscription$: Subscription = new Subscription();

  @ViewChild('ps') perfectScrollbar: PerfectScrollbarComponent;

  constructor(private taskService: TaskService,
    private cdr: ChangeDetectorRef,
    private alertifyService: AlertifyService) { }

  ngOnInit() {
    this.criteria.filters.archived = false;
    this.taskService.getPaginated(this.criteria).subscribe(not=> {
      setTimeout(() => {
        if(not && not.results){
          this.tasksData = not.results;
        }
        this.cdr.detectChanges();
      },600);
    },
    error=>{
      setTimeout(() => {
        this.loading = false;
        this.error = true;
      }, 600);
    });


    this.timerTask = TimerObservable.create(0, 50000);
    this.subscription$ = this.timerTask.subscribe(t => {
      this.getUnreadTasks();
    });
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  openTasks() {
    if (this.opened) {
      this.loadTasks();
    }
  }

  get unReadTasks() {
    return this.unreadTasks;
  }

  onHidden(): void {
    this.opened = false;
  }
  onShown(): void {
    this.opened = true;
  }
  navigate(task: any) {
    let url = task.url;
    if (url){
      this.markAsRead(task, true);
    }
  }


    markAsRead(task: Task, navigate?){
    if(!task.read){
      this.taskService.read(task.id).subscribe((n:any)=> {
        task.read= true;
        task.versionNumber = n.data.versionNumber;
        this.unreadTasks--;

        if (navigate){
          var baseRef = environment.server;

          if (!baseRef.endsWith("/")) {
            baseRef += "/";
          }

          window.location.href = baseRef + task.url;
        }

        this.cdr.detectChanges();
      },
      error=>{
        this.alertifyService.error(error);
      });
    } else if (navigate){
      var baseRef = environment.server;

      if (!baseRef.endsWith("/")) {
        baseRef += "/";
      }

      window.location.href = baseRef + task.url;
    }
  }

  markAsUnread(task: any) {
    if (task.read) {
      this.taskService.unread(task.id).subscribe((n: any) => {
        task.read = false;
        task.versionNumber = n.data.versionNumber;
        this.unreadTasks++;
        this.cdr.detectChanges();
      },
        error => {
          this.alertifyService.error(error);
        });
    }
  }

  getUnreadTasks() {
    this.taskService.getCount().subscribe((resp) => {
      if (this.isLoaded && this.unreadTasks != resp.total) {
        this.tasksData = [];
        this.loadTasks();
      }

      if (resp.beep) {
        this.audio.play();
      }

      this.unreadTasks = resp.total;
      this.cdr.detectChanges();
    },
      error => { }
    );
  }

  loadTasks() {
    this.loading = true;
    this.error = false;
    this.cdr.detectChanges();
    let criteria = Object.assign({}, this.criteria);
    this.taskService.getPaginated(criteria).subscribe(not => {
      setTimeout(() => {
        if (not && not.results) {
          this.tasksData = not.results;
        }

        let index = 0;
        this.tasksData.forEach(element => {
          this.tasksData[index].date = moment(this.tasksData[index].screenDate).format('YYYY-MM-DD');
          this.tasksData[index].time = moment(this.tasksData[index].screenDate).format('HH:mm:ss');
          index++;
        });

        this.tasksData = _.groupBy(this.tasksData, 'date');
        let keys = [];
        for (let key in this.tasksData) {
          keys.push({ key: this.checkDate(key), value: this.tasksData[key] });
        }
        this.tasksData = keys;

        this.isLoaded = true;
        this.loading = false;
        this.cdr.detectChanges();
      }, 600);
    },
      error => {
        setTimeout(() => {
          this.loading = false;
          this.error = true;
        }, 600);

      });
  }


  checkDate(date: any) {
    var a = new Date(date);
    var yesterday = new Date();
    var today = new Date();
    yesterday.setDate(today.getDate() - 1);

    a = this.removeTime(a);
    yesterday = this.removeTime(yesterday);
    today = this.removeTime(today);

    if (a.getTime() == today.getTime())
      return "generic.label.today";
    else if (a.getTime() == yesterday.getTime())
      return "generic.label.yesterday";
    else
      return moment(date).format('DD-MM-YYYY');
  }

  removeTime(date: any) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0, 0);
    return date;
  }

  openTasksPage(){
    var baseRef = environment.server;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }

    let path = 'web/#/notifier/nt/tasks';
    window.location.href = baseRef + path;
  }

}
